export default "__VITE_ASSET__Czx2wc3F__"